import { useState } from 'react';
import BookSteps from './BookSteps';
import StaySummary from './StaySummary';

function digitsOnly(value) {
  return value.replace(/\D/g, '');
}

function formatCard(value) {
  return digitsOnly(value).slice(0, 16).replace(/(\d{4})(?=\d)/g, '$1 ');
}

function formatExpiry(value) {
  const digits = digitsOnly(value).slice(0, 4);
  if (digits.length <= 2) return digits;
  return `${digits.slice(0, 2)}/${digits.slice(2)}`;
}

export default function PaymentPage({ search, room, guest, onBack, onConfirm }) {
  const [pay, setPay] = useState({
    cardName: `${guest.first} ${guest.last}`.trim(),
    cardNumber: '',
    expiry: '',
    cvc: '',
    terms: false,
  });

  const submit = (e) => {
    e.preventDefault();
    const number = digitsOnly(pay.cardNumber);
    const expiry = digitsOnly(pay.expiry);
    const cvc = digitsOnly(pay.cvc);
    if (!pay.cardName.trim() || number.length < 16 || expiry.length !== 4 || cvc.length < 3 || !pay.terms) return;
    onConfirm({
      last4: number.slice(-4),
      cardName: pay.cardName.trim(),
      paid: false,
    });
  };

  return (
    <div className="page page-book">
      <div className="wrap">
        <div className="crumbs">
          <button onClick={onBack}>Guest details</button>
          <span>›</span>
          <span>Payment</span>
        </div>
        <BookSteps current={1} />
        <header className="book-head">
          <p className="stay-bar-kicker">Step 2 of 3</p>
          <h1 className="results-title">Payment and review</h1>
          <p className="book-lead">Guarantee the stay with a card. You pay at the villa.</p>
        </header>
        <div className="checkout-layout">
          <form className="checkout-form book-panel" onSubmit={submit}>
            <p className="guest-chip">
              <strong>{guest.first} {guest.last}</strong>
              <span>{guest.email}</span>
              <span>{guest.phone}</span>
            </p>
            <section className="book-section">
              <h2>Guarantee with a card</h2>
              <p className="price-note">
                A card is held as guarantee. This demo does not process a real payment.
              </p>
              <label className="field-label" htmlFor="card-name">Name on card</label>
              <input
                id="card-name"
                autoComplete="cc-name"
                value={pay.cardName}
                onChange={(e) => setPay({ ...pay, cardName: e.target.value })}
                required
              />
              <label className="field-label" htmlFor="card-number">Card number</label>
              <input
                id="card-number"
                inputMode="numeric"
                autoComplete="cc-number"
                placeholder="ACCT-000003"
                value={pay.cardNumber}
                onChange={(e) => setPay({ ...pay, cardNumber: formatCard(e.target.value) })}
                required
              />
              <div className="field-grid">
                <div>
                  <label className="field-label" htmlFor="card-expiry">Expiry</label>
                  <input
                    id="card-expiry"
                    inputMode="numeric"
                    autoComplete="cc-exp"
                    placeholder="MM/YY"
                    value={pay.expiry}
                    onChange={(e) => setPay({ ...pay, expiry: formatExpiry(e.target.value) })}
                    required
                  />
                </div>
                <div>
                  <label className="field-label" htmlFor="card-cvc">CVC</label>
                  <input
                    id="card-cvc"
                    inputMode="numeric"
                    autoComplete="cc-csc"
                    placeholder="123"
                    value={pay.cvc}
                    onChange={(e) => setPay({ ...pay, cvc: digitsOnly(e.target.value).slice(0, 4) })}
                    required
                  />
                </div>
              </div>
            </section>
            <label className="terms-check">
              <input
                type="checkbox"
                checked={pay.terms}
                onChange={(e) => setPay({ ...pay, terms: e.target.checked })}
                required
              />
              <span>I agree to the booking terms and cancellation policy for this stay.</span>
            </label>
            <button className="see-btn book-submit" type="submit">Book now</button>
          </form>
          <StaySummary search={search} room={room} />
        </div>
      </div>
    </div>
  );
}
